<template>
  <div class="list-body">
      <div class="top">
            <div class="back" @click="back">
                <i class="iconfont icon-left-01"></i>
            </div>
            <div class="top-tab-name">
                <ul class="top-ul">
                <!-- <li class="top-tab" @click="cur=index" v-for="(item,index) in titName" :key="index" :class="{active:cur==index}">{{item}}</li> -->
                    <li @click="cur=0" class="top-tab" :class="{active:cur==0,show:shopActiveShow}">主题活动</li>
                    <li @click="shopActive" class="top-tab" :class="{active:cur==1}" v-show="shopActiveShow">广告推送
                        <i class="iconfont icon-HOT"></i>
                    </li>
                </ul>

            </div>
      </div>

    <!-- <div class="box">
        <div></div>
    </div> -->

      <div class="content">

            <div v-if="$store.state.THEME_ACTIVITY_DATA[0].length>0 || $store.state.THEME_ACTIVITY_DATA[1].length>0" class="con-box">

                <ul class="cont-ul" v-if="$store.state.THEME_ACTIVITY_DATA[0].length>0">

                    <li v-for="(item,index) in $store.state.THEME_ACTIVITY_DATA[0]"  :key="index"  @click="seleted(item,2)">
                        <!--<router-link :to='' >-->
                        <a>
                            <div class="act-li-left">
                                <p class="act-name">{{item.title}}</p>
                                <div class="art-li-cen">
                                    <span class="art-active">{{item.status == 0 ? '进行中' : '即将开始'}}</span>
                                    <span class="art-time">{{item.s_eTime}}</span>
                                </div>
                                <div class="art-li-cen">
                                    <p class="art-time art-people">
                                        <span>{{item.storeLen}}</span>
                                        <span>企业参加</span>
                                    </p>
                                    <p class="art-time art-people">
                                        <span>{{item.count}}</span>
                                        <span>人围观</span>
                                    </p>
                                </div>
                            </div>
                            <div class="act-li-right">
                                <img :src="item.topic">
                            </div>
                        </a>
                        <!--</router-link>-->
                    </li>

                </ul>

                <div class="parting" v-if="$store.state.THEME_ACTIVITY_DATA[1].length>0" >
                    <div class="fg"></div>
                    <div class="font">往期活动</div>
                    <div class="fg"></div>
                </div>

                <ul class="cont-ul" v-if="$store.state.THEME_ACTIVITY_DATA[1].length>0">

                    <li v-for="(item,index) in $store.state.THEME_ACTIVITY_DATA[1]" :key="index"  @click="seleted(item,2)">
                        <!--<router-link>-->
                        <a>

                            <div class="act-li-left">
                                <p class="act-name-end">{{item.title}}</p>
                                <div class="art-li-cen">
                                    <span class="art-active-end">已经结束</span>
                                    <span class="art-time">{{item.s_eTime}}</span>
                                </div>
                                <div class="art-li-cen">
                                    <p class="art-time art-people">
                                        <span>{{item.storeLen}}</span>
                                        <span>企业参加</span>
                                    </p>
                                    <p class="art-time art-people">
                                        <span>{{item.count}}</span>
                                        <span>人围观</span>
                                    </p>
                                </div>
                            </div>

                            <div class="act-li-right">
                                <img :src="item.topic">
                            </div>

                        </a>
                        <!--</router-link>-->
                    </li>

                </ul>

          </div>

            <div v-else class="act-null" >
                <i class="iconfont icon-huodong1"></i>
                <span>暂无主题活动</span>
          </div>

      </div>
  </div>
</template>

<script>

import {getActivityCount} from  '@/config/prepare'
export default {
  name: '',

      data () {
        return {
            isMounted:false,
            cur:0,
            titName:['主题活动','广告推送'],
        }
      },

    computed:{
        shopActiveShow(){
            return this.$store.state.ACTIVITY_DATA.length
        }
    },


    created(){
      this.$message.load(true)
    },

    methods: {
      tabclick(){
          // console.log(this.index)
      },

      back(){

          this.$mapStep.type = '';
          this.$router.replace('/map');

      },

      shopActive(){

          if(this.$store.state.ACTIVITY_DATA.length == 0){this.$message.info('暂无企业活动');return;}

          if(this.$BRT.ready){  //地图已加载

              this.cur = 1;
              this.$router.replace('/map');
              this.bus.$emit('showShopActive');
              this.$mapStep.type = 'shopActive';

          }else{    //地图未加载

              this.$mapStep.type = '';
              this.$BRT.$urlParam.shopActive.status =true;
              this.$router.replace('/map');

          }

      },

      seleted(item,type){

          this.$store.state.ACTIVITY_DATA_DETEIL = item;

          this.$router.replace(`/details/${type}/${item.id}`)
      },

      mountedEvent(){

          let state = this.$store.state,
              THEME_ACTIVITY_DATA = state.THEME_ACTIVITY_DATA,
              ACTIVITY_DATA = state.ACTIVITY_DATA;

          this.cur = 0;

          if(!THEME_ACTIVITY_DATA.length){
              this.bus.$emit('getMainActiveList',{})
          }

          if(!ACTIVITY_DATA.length){
              this.bus.$emit('getShopActive',{})
          }

          getActivityCount(this.$store,this.$store.state.THEME_ACTIVITY_DATA,2,true,false);

          this.$nextTick(()=>{
              this.$message.load(false)
          })

          //更新主题活动列表
          // this.bus.$emit('getMainActiveList',{time:0,callback:res=>{
          //
          //         this.$store.state.ACTIVITY_DATA_DETEIL = '';
          //         getActivityCount(this.$store,this.$store.state.THEME_ACTIVITY_DATA,2,true,false);
          //
          //     }})
          //
          // //更新店铺活动列表
          // this.bus.$emit('getShopActive',{time:0})

      }
  },


    activated(){
          if(this.isMounted){
              this.isMounted = false;
          }else{
              this.mountedEvent();
          }
    },


    mounted(){

        this.isMounted = true;
        this.mountedEvent();
    },

    beforeDestroy(){
        // getActivityCount();
    }
}
</script>

<style lang="less">

    @import "../../../../styles/cssBlock.less";
    @purple:#ca3cca;
    @height:50px;
    .list-body{
         height: 100%;
        display: flex;
        flex-direction: column;

        .top{
            width: 100%;
            height: @90px;
            background-color: @themeReverseColor;
            display: flex;
            flex-shrink: 0;
            > .back{
                width: @90px;
                height: @90px;
                line-height: @90px;
                text-align: center;
                color: @fontColorA1;
                i{
                    font-size: @35px
                }
            }
            .top-tab-name{
                width: calc(100% - @90px);
                padding-right: @90px;
                display: flex;
                justify-content: center;
                > .top-ul{
                    display: flex;
                    width: 100%;
                    .top-tab{
                        font-size: @fontSizeA4;
                        float: left;
                        padding: 0 @20px;
                        line-height: @90px;
                        color: @fontColorV1;
                        list-style: none;
                        position: relative;
                        margin: auto;
                        i{
                            position: absolute;
                            top: -@15px;
                            right: -@60px;
                            font-size: @70px;
                            color: @warningColor;
                        }
                    }
                    > .active{
                        color:@purple;

                        &.show{
                            border-bottom: solid 2px @purple;
                        }

                    }
                }

            }

        }
        .content{

            flex: 1;
            overflow: hidden;
            overflow-y: auto;
            &::-webkit-scrollbar{
                display: inline-block;
                width: 0px;
            }

            padding:0 @standartSpaceA7;
            .con-box{
                > .cont-ul li{
                    padding: @standartSpaceA3 @standartSpaceA4;
                    margin: @standartSpaceA5 0;
                    background-color: #ffffff;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    border-radius: 5px;
                    a{
                        text-decoration: none;
                        display: flex;
                        justify-content:space-between;
                        &:active{
                            color: @fontColorA1;
                        }
                        > .act-li-left{
                            float: left;
                            overflow: hidden;
                            > .act-name{
                                font-weight: bold;
                                font-size: @fontSizeA4;
                                line-height: @50px;
                                color: @fontColorA1;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }
                            > .act-name-end{
                                font-weight: bold;
                                font-size: @fontSizeA5;
                                line-height: @50px;
                                color: @fontColorA3;
                            }
                            > .art-li-cen{
                                font-size: @fontSizeA6;
                                display: flex;
                                align-items:center;
                                flex-wrap: nowrap;
                                white-space: nowrap;

                                span:first-child{
                                    border-radius: 3px;
                                    font-size: @fontSizeA6
                                }
                                > .art-active{
                                    background-color: @purple;
                                    color: @fontColorA5;
                                    padding: 3px;
                                    margin-right: 10px;
                                }
                                > .art-active-end{
                                    color: @fontColorA5;
                                    background-color: @fontColorA3;

                                    padding: 3px;
                                    margin-right: 10px;
                                }
                                > .art-time{
                                    font-size: @fontSizeA6;
                                    color: @fontColorA3;
                                    line-height: 25px;
                                    padding-right: 10px;
                                    color: @fontColorA2;

                                }
                                > .art-people{
                                    font-size: @fontSizeA6;
                                    color:@fontColorA3;
                                }
                            }
                        }
                    > .act-li-right{
                        width: @220px;
                        height: @135px;
                        border-radius: 3px;
                        flex-shrink: 0;
                        overflow: hidden;
                        > img{
                            width: 100%;
                            height: 100%;
                            border: none;
                        }
                    }
                    }

                }
                > .parting{
                    display: flex;
                    color: @fontColorA3;
                    font-size: @fontSizeA6;
                    align-items:center;
                    margin: @standartSpaceA4 0px;
                    .fg{
                        width: 35%;
                        height: 1px;
                        background-color: @borderColorA2;
                    }
                    .font{
                        width: 30%;
                        text-align: center;
                    }
                }
            }
            > .act-null {

                .flexCenter();
                justify-content: center;
                align-items: center;
                flex-direction: column;

                padding: @standartHeightA1 0px;
                background-color: @themeReverseColor;
                //box-shadow: @shadowbox;
                border-radius: 5px;
                margin-top: @standartSpaceA4;
                color: @fontColorA3;
                font-size: @fontSizeA6;

                >i{
                    font-size: @60px;
                }

            }
        }
     }


// .box {
//     position: relative;
//     &::before{
//         content: '';
//         display: block;
//         padding-top: 50%;
//     }

//     > div{
//         position: absolute;
//         left: 0;
//         right: 0;
//         top: 0;
//         bottom: 0;
//         background-color: red;
//         z-index: 10;
//     }
// }

</style>
